import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import _, { debounce } from "lodash";
import React, {
  useCallback,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import { RxCross2 } from "react-icons/rx";
import { ReactComponent as FilterIcon } from "../../assests/FiltersIcon.svg";
import { Button, Dropdown, Form } from "react-bootstrap";
import { FiSearch } from "react-icons/fi";
import { AiOutlinePieChart } from "react-icons/ai";
import { IoPersonAddOutline } from "react-icons/io5";
import { FiUserPlus } from "react-icons/fi";
import { FiUserMinus } from "react-icons/fi";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import ViewRecalledEpisodes from "../../assests/viewrecalledepisodes.svg";
import { MdOutlinePlaylistRemove } from "react-icons/md";
import { RiRefreshLine } from "react-icons/ri";
import RecallIcon from "../../assests/recallIcon.svg";
import { styled } from "@mui/material/styles";
import { MdHideImage } from "react-icons/md";
// import Button from '@mui/material/Button';
import Typography from "@mui/material/Typography";
import "react-datepicker/dist/react-datepicker.css";
import {
  mode,
  setMode,
  getauditData,
  getAuditFiles,
  getAuditRows,
  getAuditRowsByFileName,
  getSearchData,
  getSearchRecommendations,
  recall_episode,
  getUsers,
  episodeAssignedUsers,
  flag_and_unflag,
  episodeUnAssignedUsers,
  fetchUnassignedEpisodes
} from "../../api/Service";
import refresh from "../../assests/reload.png";
import SearchIcon from "../../assests/search-lg.png";
import { FilterLines } from "../../assests/svgImages/Images";
import CloseFilter from "../../assests/x-close.png";
import { extractFileName } from "../../utils/util";
import WorkFlowFilters from "../filters";
import "./Navbar.css";
import { Spinner } from "../../common/Helper";
import InfiniteScroll from "../../../codercompanion/components/infinite-scroll";
import { Link, useNavigate } from "react-router-dom";
import axiosInstance from "../../../../axiosinterceptor";
import { toast, ToastContainer } from "react-toastify";
import AssignedToModal from "../filters/AssignedToModal";
import userSearchIcon from "../../assests/search-icon.png";
import avatar from "../../assests/Avatar.png";
import assgineTickIcon from "../../assests/assgine-tick.png";
import downArrow from "../../assests/downarrow.png";
import { MdDashboard } from "react-icons/md";
// import Button from '@mui/material/Button';
import Tooltip from "@mui/material/Tooltip";
import { CiSaveDown2 } from "react-icons/ci";
// import {useNavigate} from "react-router-dom"
const showUnassignLoadingText = () => {
  return (<div className="loading-assigne-modal-overlay-fade z-3">
    <div className="loading-modal-content-section">
      <p>Unassigning is in progress, Please wait...</p>
      <Spinner />
    </div>
  </div>)

}
const showLoadingText = () => {
  return (
    <div className="loading-assigne-modal-overlay-fade z-3">
      <div className="loading-modal-content-section">
        <p>Assigning is in progress, Please wait...</p>
        <Spinner />
      </div>
    </div>
  );
};

function Navbar({
  mode,
  setMode,
  updatedAuditRows,
  handleRefreshClick,
  setAuditDetails,
  setIsRowsLoading,
  isRowsLoading,
  getAuditRowsByFilter,
  appliedFilters,
  setAppliedFilters,
  setHasMore,
  setAuditRows,
  setflagAuditRows,
  flagauditRows,
  getAuditRowsData,
  setPage,
  editFlageData,
  selectedEpisodeRows,
  setSelectedEpisodeRows,
  isAllEpisodesSelected,
  setIsAllEpisodesSelected,
  recall_page,
  setRecall_page,
  searchEpisodeIdentifier,
  setSearchEpisodeIdentifier,
  recommendations,
  setRecommendations,
  selectAllFiles,
  setSelectAllFiles,
  selectedColumns,
  toggleColumnSelection,
  isAssigned,
  setIsAssigned,
  unassined_page,
  setUnassined_page,
  addUnassignReason,
  setAddUnassignReason,
  isMobile, // New prop to determine mobile view
  isDrawerOpen, // New prop to sync drawer state
  setIsDrawerOpen, // New prop to control drawer state
}) {
  const [showModal, setShowModal] = useState(false);
  const [openConfirmUnAssgineModal, setOpenConfirmUnAssgineModal] = useState(false);
  const [isRecommendationsLoading, setIsRecommendationsLoading] =
    useState(false);
  const [auditFiles, setAuditFiles] = useState([]);
  const [isRecallLoading, setIsRecallLoading] = useState(false);
  const [isRecommendationOpen, setIsRecommendationOpen] = useState(false);
  const [isUnassignLoading, setIsUnassignLoading] = useState(false)
  const recomandationRef = useRef();
  const navigate = useNavigate();
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));
  const admin = permissions?.admin || false;

  // const [appliedFilters, setAppliedFilters] = useState({

  //     episode_identifier:[],
  //     insurer_identifier: [],
  //     priority_value: [],
  //     status: [],
  //     file_type: [],
  //     header_id: [],
  //     coder_name: [],
  //     admission_date_from: "",
  //     admission_date_to: "",
  //     separation_date_from: "",
  //     separation_date_to: "",
  //     length_of_stay: [],
  //     assigned_by: [],
  //     assigned_to: [],
  //     uploaded_by_user_name : [],
  //     hcp_line_updated_at : [],
  //     case_mix_speciality: [],
  //     audit_ref_no:[],
  //     short_description:[]

  // });
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMany, setHasMany] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const [filtersObj, setFiltersObj] = useState(appliedFilters);
  const assginedUserId = JSON.parse(sessionStorage.getItem("userId"));
  const [openUserAssgineeModal, setOpenUserAssgineeModal] = useState(false);
  const [openConfirmAssgineModal, setOpenConfirmAssgineModal] = useState(false);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [searchAssgineeUserName, setSearchAssgineeUserName] = useState("");
  const [addAssignReason, setAddAssignReason] = useState("");
  const [getAllUsers, setGetAllUsers] = useState([]);
  const [assgineCurrentPage, setAssgineCurrentPage] = useState(1);
  const [selectedAssgineeUser, setSelectedAssgineeUser] = useState(null);
  const [hasMoreUsers, setHasMoreUsers] = useState(true);
  const [openAccordion, setOpenAccordion] = useState([]);
  const [isAssigneLoading, setIsAssigneLoading] = useState(false);
  const [downdloadLoader, setdownLoadLoader] = useState(false);


  // const [noUsersMessage, setNoUsersMessage] = useState("")

  const toggleModal = () => {
    setShowModal(!showModal);
    setOpenAccordion([]);
    document.body.style.overflowY = "auto";
  };
  const fetchRecommendations = useCallback(
    debounce((filters, identifier, recall_page, unassigned_page) => {
      setIsRecommendationsLoading(true);
      getSearchRecommendations(filters, identifier, recall_page, unassigned_page)
        .then((res) => {
          if (res.message) {
            toast.error("No Results Found");
            setRecommendations([]);
          }
          const unique_episode_identifiers = res.unique_episode_identifiers;
          setRecommendations([...unique_episode_identifiers]);
        })
        .catch((err) => {
          // console.log("Search Recommendations Error::", err.message);
          setRecommendations([]);
        })
        .finally(() => setIsRecommendationsLoading(false));
    }, 500),

    [flagauditRows]
  );

  const fetchUsers = useCallback(
    debounce((userName) => {
      setLoadingUsers(true);
      setHasMoreUsers(true);
      getUsers(userName, assgineCurrentPage)
        .then((res) => {
          if (res.message) {
            toast.error(res.message);
          }
          const { users } = res.data;
          setGetAllUsers(users);
        })
        .catch((err) => {
          // console.log("No Users Found::", err.message);
          // setNoUsersMessage(err.message)
          setGetAllUsers([]);
        })
        .finally(() => setLoadingUsers(false));
    }, 500),
    []
  );

  const handleSearchRecommendClick = (rowId) => {
    setSearchEpisodeIdentifier(rowId);
    getSearchResults(rowId);
    const updatedFilters = {
      ...appliedFilters,
      episode_identifier: [rowId],
    };
    setAppliedFilters(updatedFilters);
    setIsRecommendationOpen(false);
    setRecommendations([]);
  };
  // const handleSearch = (event) => {
  //   const { value } = event.target;
  //   setSearchEpisodeIdentifier(value);
  //   console.log(appliedFilters)
  //   if (value) {
  //     setAppliedFilters((prev) => ({
  //       ...prev,
  //       episode_identifier: value
  //         ? [...(prev.episode_identifier || []), value.toUpperCase()]
  //         : [],
  //     }));
  //     fetchRecommendations(appliedFilters,value);
  //   } else {
  //     setRecommendations([]);
  //     setIsRecommendationsLoading(false);
  //   }
  // };

  const handleSearch = (event) => {
    const { value } = event.target;
    setSearchEpisodeIdentifier(value);
    if (value) {
      setIsRecommendationOpen(true);
    } else {
      setIsRecommendationOpen(false);
    }
    // Create the updated filters
    const updatedFilters = {
      ...appliedFilters,
      episode_identifier: value ? [value.toUpperCase()] : [],
    };

    // Update appliedFilters state
    setAppliedFilters(updatedFilters);

    if (value) {
      fetchRecommendations(updatedFilters, value, recall_page, unassined_page);
    } else {
      setRecommendations([]);
      setIsRecommendationsLoading(false);
    }
  };

  const searchAssgineUsers = (event) => {
    const { value } = event.target;
    setSearchAssgineeUserName(value);
    fetchUsers(value);
  };

  const getSearchResults = (searchData) => {
    //console.log('searchData',searchData);
    setIsRowsLoading(true);
    getSearchData(searchData, appliedFilters, flagauditRows, unassined_page)
      .then((response) => {
        //console.log('UpdatedAudit',response.data.audited_rows);
        updatedAuditRows(response.data.audited_rows);
        setAuditDetails({});
        setSearchEpisodeIdentifier("");
        setHasMore(false);
        setRecommendations([]);
      })
      .catch((err) => console.log("Search Results Error::", err.message))
      .finally(() => {
        setIsRowsLoading(false);
      });
  };

  const handleFilterClick = async (latestFilters = {}) => {
    const filters = { ...latestFilters, header_id: appliedFilters?.header_id };
    setAppliedFilters(filters);
    getAuditRowsByFilter(filters);
    setSelectedEpisodeRows([]);
    setIsAllEpisodesSelected(false);
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      getSearchResults(searchEpisodeIdentifier);
    }
  };

  const arraysHaveSameElements = (arr1, arr2) => {
    if (arr1.length !== arr2.length) {
      return false;
    }
    const set1 = new Set(arr1);
    const set2 = new Set(arr2);
    for (let item of set1) {
      if (!set2.has(item)) {
        return false;
      }
    }
    return true;
  };

  // function handleSelectChange(event, fileName) {
  //   // console.log("CHANGE::", fileName);
  //   const { value } = event.target;
  //   let selectedFields = [];
  //   let selectedFileNames = [];
  //   if (event.target.checked) {
  //     selectedFields = [...appliedFilters.header_id, value];
  //     selectedFileNames = [...appliedFilters.file_type, ...fileName];
  //   } else {
  //     selectedFields = [...appliedFilters.header_id];
  //     selectedFileNames = [...appliedFilters.file_type];
  //     const indexOfID = selectedFields.indexOf(value);
  //     const indexOfFiletype = selectedFileNames.indexOf(...fileName);
  //     selectedFields.splice(indexOfID, 1);
  //     selectedFileNames.splice(indexOfFiletype, 1);
  //     // console.log("CHANGE::1", selectedFields);
  //   }
  //   const filters = {
  //     ...appliedFilters,
  //     header_id: selectedFields,
  //     file_type: selectedFileNames,
  //   };
  //   const allLoadIds = [];
  //   const allFileNames = [];
  //   auditFiles.forEach((file) => {
  //     allLoadIds.push(file.header_id);
  //     allFileNames.push((file.file_name));
  //   });
  //   // console.log("IDS::::", allLoadIds, selectedFields);

  //   if (
  //     arraysHaveSameElements(allLoadIds, selectedFields) &&
  //     arraysHaveSameElements(allFileNames, selectedFileNames)
  //   ) {
  //     setSelectAllFiles(true);
  //   } else {
  //     setSelectAllFiles(false);
  //   }
  //   setAppliedFilters(filters);
  //   getAuditRowsByFilter(filters);
  // }

  function handleSelectChange(event, fileName) {
    const { value } = event.target;
    let selectedFields = [];
    let selectedFileNames = [];

    if (event.target.checked) {
      selectedFields = [...appliedFilters.header_id, value];
      selectedFileNames = [...appliedFilters.file_type, ...fileName];
    } else {
      selectedFields = appliedFilters.header_id.filter((id) => id !== value);
      selectedFileNames = appliedFilters.file_type.filter(
        (name) => !fileName.includes(name)
      );
    }

    const filters = {
      ...appliedFilters,
      header_id: selectedFields,
      file_type: selectedFileNames,
    };

    // Check if all files are selected
    const allLoadIds = auditFiles.map((file) => file.header_id);
    const allFileNames = auditFiles.flatMap((file) => file.file_name);

    setSelectAllFiles(
      arraysHaveSameElements(allLoadIds, filters.header_id) &&
      arraysHaveSameElements(allFileNames, filters.file_type)
    );

    setAppliedFilters(filters);
    getAuditRowsByFilter(filters);
  }
  const handleBreadCrumbClose = (key) => {
    handleFilterClick({ ...appliedFilters, [key]: [] });

    if (key === "priority_value") {
      setFiltersObj({ ...appliedFilters, priority_value: [] });
      setAppliedFilters({ ...appliedFilters, priority_value: [] });
    }
    if (key === "insurer_identifier") {
      setFiltersObj({ ...appliedFilters, insurer_identifier: [] });
      setAppliedFilters({ ...appliedFilters, insurer_identifier: [] });
    }
    if (key === "status") {
      setFiltersObj({ ...appliedFilters, [key]: [] });
      setAppliedFilters({ ...appliedFilters, [key]: [] });
    }

    // setFiltersObj({ [key]: [] })
  };

  const handleSelectAllCheckboxes = (e) => {
    const { checked } = e.target;
    let selectedFields = [];
    let selectedFileNames = [];
    setSelectAllFiles(checked);
    if (checked) {
      // console.log("ALL:::", e.target.checked, auditFiles);
      auditFiles.forEach((file) => {
        selectedFields.push(file.header_id);
        selectedFileNames.push(file.file_name);
      });
    } else {
      selectedFields = [];
      selectedFileNames = [];
    }
    const filters = {
      ...appliedFilters,
      header_id: selectedFields,
      file_type: selectedFileNames,
    };
    //console.log("FILTERS::::", filters);
    setAppliedFilters(filters);
    getAuditRowsByFilter(filters);
  };

  // key is to match with appliedFilters keys
  const breadCrumbs = [
    // { label: "Status", key: "status" },
    { label: "Priority Value", key: "priority_value" },
    { label: "Insurer Identifier", key: "insurer_identifier" },
  ];
  //console.log("APPLIED:::", appliedFilters, auditFiles);
  const getData = async (page, load_more) => {
    try {
      setIsLoading(true);
      const response = await getAuditFiles(page);
      //console.log("AUDIT_FILES:::", response);
      if (load_more) {
        setAuditFiles([...auditFiles, ...response]);
      } else {
        setAuditFiles(response);
      }
      setHasMany(true);
      const newPage = currentPage + 1;
      setCurrentPage(newPage);
    } catch (error) {
      console.log("Error fetching audit files:", error);
      setHasMany(false);
      if (!load_more) {
        setAuditFiles([]);
      }
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {

    getData(1);
  }, []);
  //console.log('allauditfiles',flagauditRows);
  useEffect(() => {
    // console.log(mode);
  }, []);
  const assginToHandler = (e) => {
    if (selectedEpisodeRows && !selectedEpisodeRows.length > 0) {
      toast.info("Please Select Some Episodes");
    } else {
      if (selectedAssgineeUser === null) {
        toast.info("Please Select User");
      } else {
        setOpenUserAssgineeModal(false);
        setOpenConfirmAssgineModal(true);
        setSearchAssgineeUserName("");
      }
    }
  };

  const handleAssgintoUsers = (data) => {
    if (selectedEpisodeRows && !selectedEpisodeRows?.length > 0) {
      toast.info("Please Select Some Episodes");
    }
    if (selectedEpisodeRows && selectedEpisodeRows?.length > 0) {
      if (selectedAssgineeUser?.user_id === data?.user_id) {
        return;
      }
      setSelectedAssgineeUser(data);
    }
  };

  const assgineeModalHandle = (e) => {
    setOpenUserAssgineeModal((prev) => {
      const modalIsOpened = !prev;
      if (modalIsOpened) {
        setHasMoreUsers(true);
        setLoadingUsers(true);
        getUsers(searchAssgineeUserName, assgineCurrentPage)
          .then((res) => {
            if (res.message) {
              toast.error(res.message);
            }
            const { users } = res.data;
            setGetAllUsers(users);
          })
          .catch((err) => {
            console.log("No Users Found::", err.message);
          })
          .finally(() => setLoadingUsers(false));
      } else {
        setGetAllUsers([]);
        setSearchAssgineeUserName("");
        setSelectedAssgineeUser(null);
        setAssgineCurrentPage(1);
      }
      return modalIsOpened;
    });
  };

  const getMoreUsers = async (assgineCurrentPage, load_more) => {
    try {
      setLoadingUsers(true);
      const response = await getUsers(
        searchAssgineeUserName,
        assgineCurrentPage
      );
      const { users } = response.data;
      const mergedUsers = [
        ...new Map(
          [...getAllUsers, ...users].map((item) => [item.user_id, item])
        ).values(),
      ];
      if (load_more) {
        setGetAllUsers(mergedUsers);
      } else {
        setGetAllUsers(users);
      }
      setHasMoreUsers(true);
      const newPage = assgineCurrentPage + 1;
      setAssgineCurrentPage(newPage);
    } catch (error) {
      console.log("Error fetching users:", error);
      setHasMoreUsers(false);
      setAssgineCurrentPage(1);
      if (!load_more) {
        setGetAllUsers([]);
      }
    } finally {
      setLoadingUsers(false);
    }
  };

  useEffect(() => {
    if (openUserAssgineeModal) {
      getMoreUsers(1, true);
    }
  }, [openUserAssgineeModal]);

  const episodeUserAssignments = useCallback(() => {
    setIsAssigneLoading(true);
    episodeAssignedUsers(selectedEpisodeRows, selectedAssgineeUser.user_id, assginedUserId, addAssignReason, isAllEpisodesSelected, appliedFilters, recall_page, appliedFilters.header_id, unassined_page)
      .then((repo) => {
        if (repo?.response?.status === 401) {
          const errMessage = (repo?.response?.data?.message.includes("TypeError: Cannot read properties of undefined"))
            ? "Assign failed"
            : repo?.response?.data?.message || "An unknown error occurred";
          toast.error(errMessage);
          // console.log("Episode assigned failed::", repo?.response?.data?.message);
          setGetAllUsers([])
          setSearchAssgineeUserName("");
          setSelectedAssgineeUser(null)
          setAssgineCurrentPage(1)
        } else {
          toast.success(repo.message);
          setSelectedEpisodeRows([]);
          setIsAllEpisodesSelected(false);
          // window.location.reload();
          window.location.reload();
          setHasMoreUsers(true)
        }
      })
      .catch((err) => {
        const errMessage = err.message.includes("Cannot read properties") ? "Assign failed" : err.message
        toast.error("Episodes Assignement Failed");
        // console.log("Episode assigned failed::", err.message);
        setGetAllUsers([])
        setSearchAssgineeUserName("");
        setSelectedAssgineeUser(null)
        setAssgineCurrentPage(1)
      }
      )
      .finally(() => setIsAssigneLoading(false));
  }, [selectedEpisodeRows, selectedAssgineeUser, assginedUserId, addAssignReason, isAllEpisodesSelected, filtersObj]);


  const handleAssignReason = () => {
    setOpenConfirmAssgineModal(!openConfirmAssgineModal);
    episodeUserAssignments();
  };

  const cancelAssignReason = () => {
    setOpenConfirmAssgineModal(false);
  };
  const episodeUnassgineHandler = () => {
    if (selectedEpisodeRows && selectedEpisodeRows?.length > 0) {
      setOpenConfirmUnAssgineModal(true);
    } else {
      toast.info("Please Select Some Episodes")
    }
  }
  const callAPI = () => {
    episodeUnAssignedUsers(selectedEpisodeRows, assginedUserId, addUnassignReason, isAllEpisodesSelected, appliedFilters, !recall_page, appliedFilters.header_id)
      .then((res) => {
        toast.success(res.message ? res.message : "Episodes are unassigned and e-mail has been sent successfully");
        setTimeout(() => {
          window.location.reload()
        }, 3000)

        setOpenConfirmUnAssgineModal(false);
      })
      .catch((err) => {
        toast.error("Episode unassigned failed");
        setOpenConfirmUnAssgineModal(true);
        //  console.log("Episode unassigned failed::", err.message)
      })
      .finally(() => { setIsUnassignLoading(false) })
  }
  const getUnassignedEpisodes = () => {
    // console.log(assginedUserId,"assigned by")
    fetchUnassignedEpisodes(assginedUserId, filtersObj, !recall_page, appliedFilters.header_id)
      .then((res) => {
        toast.error(res.message ? res.message : "No More Data");
        // window.location.reload()
        // console.log(res?.unassigned_episodes);
        setAuditRows(res?.unassigned_episodes)
      })
      .catch((err) => {

        toast.error("Failed to fetch data");

        // console.log("Episode unassigned failed::", err.message)
      })
  }
  const handleFlagUnFlag = () => {
    if (selectedEpisodeRows && !selectedEpisodeRows?.length > 0) {
      toast.info("Please Select Some Episodes");
    } else if (!flagauditRows) {
      flag_and_unflag(
        selectedEpisodeRows,
        selectedAssgineeUser?.user_id,
        assginedUserId,
        addAssignReason,
        isAllEpisodesSelected,
        filtersObj,
        !recall_page,
        appliedFilters.header_id
      )
        .then((res) => {
          // toast.success(res.data.message);
          window.location.reload();
        })
        .catch((err) => {
          toast.error(err.message);
          // console.log("Episode assigned failed::", err.message);
        });
    } else {
      flag_and_unflag(
        selectedEpisodeRows,
        selectedAssgineeUser?.user_id,
        assginedUserId,
        addAssignReason,
        isAllEpisodesSelected,
        filtersObj,
        !recall_page,
        appliedFilters.header_id
      )
        .then((res) => {
          //toast.success(res.data.message);
          window.location.reload();
        })
        .catch((err) => {
          toast.error(err.message);
          // console.log("Episode assigned failed::", err.message);
        });
    }
  };

  useEffect(() => {
    if (isRecommendationOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isRecommendationOpen]);

  const handleClickOutside = (event) => {
    if (
      recomandationRef.current &&
      !recomandationRef.current.contains(event.target)
    ) {
      setIsRecommendationOpen(false);
      setSearchEpisodeIdentifier("");
      setAppliedFilters((prevFilters) => ({
        ...prevFilters,
        episode_identifier: [],
      }));
    }
  };

  useEffect(() => {
    if (flagauditRows) {
      getAuditRowsData(1, true);
    }
  }, [flagauditRows]);
  const handleDownloadCsvFile = async () => {
    setdownLoadLoader(true);
    try {
      const response = await axiosInstance.post(
        "/ics_export_csv_file_ics",
        appliedFilters
      );
      // console.log(response.data?.data?.message, "response");
      const fileUrl = response.data?.data?.file_url;
      const Querymessage = response.data?.data?.message;
      toast.success(Querymessage)
      if (fileUrl) {
        // console.log(fileUrl, "acess the url");

        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", "auditfile.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.log("file URL not found in reposne");
      }
    } catch (error) {
      setdownLoadLoader(false);
      // console.log(error.response.data.message, "gggggg");
      toast.error(error.response.data.message);
    } finally {
      setdownLoadLoader(false);
    }
  };
  const handlemobileFilterClick = () => {
    // console.log("Filter button clicked, current isDrawerOpen:", isDrawerOpen, "setting to true");
    setIsDrawerOpen(true); // Temporarily set to true for testing
  };
  return (
    <>
      <ToastContainer autoClose={5000} />
      <div className="navbar">

        <div
          className="navbar-left-section"
        >
          {
            (flagauditRows || isAssigned) ?
              (<div className="" style={{ cursor: "pointer" }}>
                <MdOutlineKeyboardBackspace fontSize={28} onClick={() => {
                  window.location.reload();
                  handleRefreshClick()
                  setRecall_page(false);
                  setUnassined_page(false)
                }} /></div>) :
              (<div className="back-img" style={{ "margin": "0px 8px", }}>
                <MdOutlineKeyboardBackspace style={{ color: 'gray', opacity: 0.5, cursor: 'not-allowed' }} fontSize={28} onClick={() => {

                }} /></div>)
          }
          <Dropdown className="hcp-file-dropdown-webworkflow">
            <Dropdown.Toggle id="dropdown-basic">Select Files</Dropdown.Toggle>
            <Dropdown.Menu className="webworkflow-dropdown-menu">

              <InfiniteScroll
                className="load-filters"
                hasData={hasMany}
                loadMore={() => getData(currentPage, true)}
                isLoading={isLoading}
              >
                <div className="hcp-cards-container">
                  <div className="hcp-card">
                    <Form.Check
                      label="Select All"
                      id={`checkbox`}
                      type="checkbox"
                      checked={selectAllFiles}
                      onChange={handleSelectAllCheckboxes}
                    />

                  </div>
                  {auditFiles.map((item) => (
                    <div key={item.header_id} className="hcp-card">
                      <Form.Check
                        key={item.header_id}
                        id={`checkbox-${item.header_id}`}
                        type="checkbox"
                        // label={`${item.start_date} - ${
                        //   item.end_date
                        // }
                        // {item.load_id}

                        // FileName:(${item.file_name.map((eachFileItem)=>(eachFileItem))})`}

                        value={item.header_id}
                        checked={
                          selectAllFiles ||
                          appliedFilters.header_id?.includes(
                            String(item.header_id)
                          )
                        }
                        onChange={(e) =>
                          handleSelectChange(
                            e,
                            item.file_name.map((eachFileItem) => eachFileItem)
                          )
                        }
                      // style={{ width: "300px" }}
                      />
                      <label
                        htmlFor={`checkbox-${item.header_id}`}
                        className="hcp-card-content"
                      >
                        <div className="card-line date-line">
                          {item.start_date} - {item.end_date}
                        </div>
                        <div className="card-line filename-line">
                          {/* File:(${item.file_name.map((eachFileItem)=>(eachFileItem))}) */}
                          File: {item.file_name.join(", ")}
                        </div>
                        <div className="card-line loadid-line">
                          Load ID: {item.load_id}
                        </div>
                      </label>
                    </div>
                  ))}
                </div>
              </InfiniteScroll>
            </Dropdown.Menu>
          </Dropdown>

          {/* <button className="downloadcsv-btn" onClick={handleDownloadCsvFile}>
          <span style={{ marginRight: "5px" }}>Download CSV</span>
 
          {downdloadLoader ? (
            <span className="download-loader"></span>
          ) : (
            <CiSaveDown2
              style={{ color: "#fff", fontWeight: 600, marginTop: "-2px" }}
            />
          )}
        </button> */}

          <div
            className="side-navbar-item1 navbar-hover"
            onClick={handleDownloadCsvFile}
          >
            {downdloadLoader ? (
              <span className="download-loader"></span>
            ) : (
              <CiSaveDown2
                className="navbar-icon"
              />
            )}

            <span className="navbar-label">
              Download CSV
            </span>
          </div>
          {isMobile && (
            <button className="filter-toggle" onClick={handlemobileFilterClick}>
              Actions
            </button>
          )}
          <div
            style={{
              display: mode === "LIGHT" ? "flex" : "none",
              justifyContent: "space-around",
              alignItems: "center",

            }}
          >
            {/* Dashboard Icon */}
            <div className="side-navbar-item1 navbar-hover" onClick={() => navigate("/workflow-dashboard")}>
              <AiOutlinePieChart className="navbar-icon" />
              <span className="navbar-label">Dashboard</span>
            </div>

            {/* Assign Dropdown */}
            <div className="">
              <Dropdown
                className="dropdown-assgine"
                show={openUserAssgineeModal}
                onToggle={assgineeModalHandle}
                autoClose="outside"
              >
                <Dropdown.Toggle
                  className={`dropdown-assine-header ${openUserAssgineeModal ? "open" : "close"
                    }`}
                > <div className="side-navbar-item1 navbar-hover">
                    <FiUserPlus
                      className="navbar-icon"
                      style={{
                        width: "20px"
                      }}
                    />
                    <span className="navbar-label" >Assign</span>
                  </div>

                  {/* <span className="navbar-label">Assign</span> */}
                </Dropdown.Toggle>

                <Dropdown.Menu className="assgine-modal-section">
                  <Dropdown.Item
                    eventKey={openUserAssgineeModal}
                    className="assgine-dropdown-item"
                  >
                    <div className="assigne-search-section">
                      <img
                        className="assigne-search-icon"
                        src={userSearchIcon}
                        alt="Search Icon"
                      />
                      <input
                        className="assgine-search-input"
                        type="text"
                        value={searchAssgineeUserName}
                        onChange={searchAssgineUsers}
                        placeholder="Search by Username or Email"
                      />
                    </div>

                    <InfiniteScroll
                      className="assgine-modal-body"
                      hasData={hasMoreUsers}
                      loadMore={() => getMoreUsers(assgineCurrentPage, true)}
                      isLoading={loadingUsers}
                    >
                      {getAllUsers?.length > 0
                        ? getAllUsers.map((user, index) => (
                          <div
                            key={index}
                            className={`assigne-user-section ${selectedAssgineeUser?.user_id === user?.user_id
                                ? "active"
                                : ""
                              }`}
                            onClick={() => handleAssgintoUsers(user)}
                          >
                            <div className="assigne-card">
                              <p>
                                <span className="assgine-user-name-icon">
                                  {user?.username?.charAt(0) || ""}
                                </span>
                              </p>
                              <p className="assigne-user-email-card">
                                <span className="assign-username">
                                  {user?.username || "User not found"}
                                </span>
                                <span className="assign-email">
                                  {user?.email || ""}
                                </span>
                              </p>
                            </div>
                            {selectedAssgineeUser?.user_id ===
                              user?.user_id && (
                                <img src={assgineTickIcon} alt="Selected" />
                              )}
                          </div>
                        ))
                        : !loadingUsers && (
                          <p className="no-usersfound">No Users Found</p>
                        )}
                    </InfiniteScroll>

                    <div className="assgine-actions-btn">
                      <button
                        className="assigne-save-btn"
                        onClick={assginToHandler}
                      >
                        Assign
                      </button>
                    </div>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              {isAssigneLoading && showLoadingText()}
              {openConfirmAssgineModal && (
                <AssignedToModal
                  handleAssignReason={handleAssignReason}
                  cancelAssignReason={cancelAssignReason}
                  addAssignReason={addAssignReason}
                  setAddAssignReason={setAddAssignReason}
                />
              )}
            </div>
            {/* Unassign button */}
            {recall_page && admin && <div className="side-navbar-item1 navbar-hover" onClick={episodeUnassgineHandler}><FiUserMinus className="navbar-icon"
              style={{
                width: "20px",
                height: "20px",
                textAlign: "center",
              }} />
              <span className="navbar-label">Unassign</span>
            </div>}
            {!unassined_page && !recall_page && <div className="side-navbar-item1 navbar-hover" onClick={episodeUnassgineHandler}><FiUserMinus className="navbar-icon"
              style={{
                width: "20px",
                height: "20px",
                textAlign: "center",
              }} />
              <span className="navbar-label">Unassign</span>
            </div>}
            {isUnassignLoading && showUnassignLoadingText()}
            {/* unassgin modal code */}
            {openConfirmUnAssgineModal && (
              <div className="unassign-reason-modal-overlay-fade z-3">
                <div className="unassign-reason-modal-content-section">
                  <div className="unassign-reason-modal-content-header">
                    <p>Add Specific Reason</p>
                  </div>
                  <div className="unassign-reason-modal-content-body">
                    <div className="unassign-reason-textarea">
                      <textarea
                        className="unassign-search-textarea"
                        type="text"
                        rows="4"
                        value={addUnassignReason}
                        onChange={(e) => setAddUnassignReason(e.target.value)}
                        placeholder="Add the reason" />
                    </div>
                  </div>
                  <div className="unassign-reason-actions-btn">
                    <button className="unassign-reason-btn-cancel" onClick={() => {
                      setAddUnassignReason("")
                      setOpenConfirmUnAssgineModal(false);
                    }}>
                      Cancel
                    </button>
                    <button className="unassign-reason-btn-save" onClick={() => {
                      setAddUnassignReason("")
                      setOpenConfirmUnAssgineModal(false)

                      setIsUnassignLoading(true)
                      callAPI()

                    }}>
                      Ok
                    </button>
                  </div>
                </div>
              </div>
            )}
            {admin && !isAssigned && <div onClick={() => {
              localStorage.removeItem("breadcrumbClick")
              setSearchEpisodeIdentifier("");
              setRecommendations([]);
              setflagAuditRows(false);
              setRecall_page(false);
              setIsAssigned(true);
              setUnassined_page(true)
              setIsAllEpisodesSelected(false);
              setSelectAllFiles(false)
              setFiltersObj({
                fileType: [],
                priorityValue: [],
                status: [],
                assigned_to: [],
                assigned_by: [],
                case_mix_speciality: [],
                insurerIdentifier: [],
                codedBy: [],
                fromAdmissionDate: "",
                toAdmissionDate: "",
                fromSeparationDate: "",
                toSeparationDate: "",
                length_of_stay: [],
              })
              setAppliedFilters({
                insurer_identifier: [],
                priority_value: [],
                episode_identifier: [],
                status: [],
                file_type: [],
                header_id: [],
                coder_name: [],
                admission_date_from: "",
                admission_date_to: "",
                separation_date_from: "",
                separation_date_to: "",
                length_of_stay: [],
                assigned_by: [],
                assigned_to: [],
                audit_ref_no: [],
                uploaded_by_user_name: [],
                hcp_line_updated_at: [],
                short_description: [],
                case_mix_speciality: [],
                drg: []
              });
              //sessionStorage.setItem("flagStatus",flagauditRows);
              // Clear existing rows and reset pagination
              //setIsRowsLoading(true);
              setAuditRows([]);
              setPage(1);
              setHasMore(true);
              getUnassignedEpisodes()
            }} className="side-navbar-item1 navbar-hover"><MdOutlinePlaylistRemove className="navbar-icon" />
              <span className="navbar-label">
                Unassigned Episodes
              </span>
            </div>}
            {/* Recall/Reflag */}
            <div
              className="side-navbar-item1 navbar-hover"
              onClick={handleFlagUnFlag}
            >
              <img src={RecallIcon} alt="Recall Icon" className="navbar-icon" style={{ width: "32px" }} />
              <span className="navbar-label">
                {!flagauditRows ? "Recall" : "Reflag"}
              </span>
            </div>

            {/* View Recalled Episodes */}

            {!flagauditRows && (
              <div className="side-navbar-item1 navbar-hover" onClick={() => {
                localStorage.removeItem("breadcrumbClick")
                setSearchEpisodeIdentifier("");
                setRecommendations([]);
                setIsAssigned(false);
                setUnassined_page(false)
                setflagAuditRows(true);
                setRecall_page(true);
                setIsAllEpisodesSelected(false);
                setSelectAllFiles(false)
                setFiltersObj({
                  fileType: [],
                  priorityValue: [],
                  status: [],
                  assigned_to: [],
                  assigned_by: [],
                  case_mix_speciality: [],
                  insurerIdentifier: [],
                  codedBy: [],
                  fromAdmissionDate: "",
                  toAdmissionDate: "",
                  fromSeparationDate: "",
                  toSeparationDate: "",
                  length_of_stay: [],
                })
                setAppliedFilters({
                  insurer_identifier: [],
                  priority_value: [],
                  episode_identifier: [],
                  status: [],
                  file_type: [],
                  header_id: [],
                  coder_name: [],
                  admission_date_from: "",
                  admission_date_to: "",
                  separation_date_from: "",
                  separation_date_to: "",
                  length_of_stay: [],
                  assigned_by: [],
                  assigned_to: [],
                  audit_ref_no: [],
                  uploaded_by_user_name: [],
                  hcp_line_updated_at: [],
                  short_description: [],
                  case_mix_speciality: [],
                  drg: []
                });
                //sessionStorage.setItem("flagStatus",flagauditRows);
                // Clear existing rows and reset pagination
                //setIsRowsLoading(true);
                setAuditRows([]);
                setPage(1);
                setHasMore(true);

                // Fetch flagged rows
                // getAuditRowsData(1);
                recall_episode({ page_number: 1 })
                  .then((res) => {
                    //console.log("auditRows Res",res);
                    if (res.data.message) {
                      toast.error(res.data.message);
                    }
                    //getAuditRows({});
                    // setAuditRows(res.res.audited_rows)
                    //setAuditRows(res.data.data.audited_rows); // Create a new array
                    // setflagAuditRows(true);
                  })
                  .catch((err) => {
                    console.log("Error: " + err.message);
                  });
              }}>
                <img className="navbar-icon"
                  src={ViewRecalledEpisodes}

                  alt="Recall Icon"

                  style={{ width: "24px", height: "28px", color: "gray" }}
                />
                <span className="navbar-label">
                  Recalled Episodes
                </span>
                {/* <span>Recalled Episodes</span> */}
              </div>
            )}

            {/* {
          (flagauditRows ||isAssigned) &&
         <div className="d-flex gap-2">
          <button className="recall-btn" onClick={()=>{
            window.location.reload();
            setRecall_page(false);
            setUnassined_page(false)
          }}>Back</button></div>
        } */}
          </div>
          {mode === "LIGHT" && (
            <div>
              <Tooltip
                title={
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                      maxHeight: "140px",
                      overflowY: "auto",
                      paddingRight: "8px",
                    }}
                  >
                    <p style={{ padding: 0, margin: 0, fontSize: "12px" }}>Selected Preferred columns</p>
                    {selectedColumns.map((column, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          minWidth: "130px",
                        }}
                      >
                        <input
                          type="checkbox"
                          id={`column-${column.id}`}
                          checked={column.checked}
                          onChange={() => toggleColumnSelection(column.id)}
                          onClick={(e) => e.stopPropagation()}
                          style={{
                            margin: 0,
                            cursor: "pointer",
                            width: "12px",
                            height: "12px",
                          }} // Reset default margins
                        />

                        <label
                          htmlFor={`column-${column.id}`}
                          style={{ cursor: "pointer" }}
                        >
                          {column.label}
                        </label>
                      </div>
                    ))}
                  </div>
                }
                arrow
                componentsProps={{
                  tooltip: {
                    sx: {
                      bgcolor: "white",
                      color: "text.primary",
                      boxShadow: 3,
                      p: 2,
                      borderRadius: "8px",
                      maxWidth: "none",
                      border: "1px solid",
                      borderColor: "divider",
                      "& .MuiTooltip-arrow": {
                        color: "white",
                        "&:before": {
                          boxShadow: 3,
                        },
                      },
                    },
                  },
                }}
              >
                <div>
                  <MdHideImage fontSize={24} />
                </div>
              </Tooltip>
            </div>
          )}

          <div className="status-Filter-values d-flex gap-2">
            {breadCrumbs.map((breadCrumb) =>
              appliedFilters[breadCrumb.key]?.length > 0 ? (
                <div className={`${breadCrumb.key}-value d-flex`}>
                  <p className="ellpsis">
                    {" "}
                    {breadCrumb.label}:
                    {appliedFilters[breadCrumb.key].map((items) => items + ",")}{" "}
                  </p>
                  <span
                    onClick={() => handleBreadCrumbClose(breadCrumb.key)}
                    className="close-filter-btn"
                  >
                    <img src={CloseFilter} alt="Close" />
                  </span>
                </div>
              ) : null
            )}
          </div>

        </div>

        <div></div>

        <div className="navbar-right-section">
          <div className="navbar-searchbar">
            <FiSearch style={{ color: "gray" }} />
            <input
              type="text"
              className="navbar-search-input"
              placeholder="Search for Episode Identifier"
              onKeyDown={handleKeyPress}
              value={searchEpisodeIdentifier.toUpperCase()}
              onChange={handleSearch}
            />
            {searchEpisodeIdentifier && (
              <RxCross2
                style={{ cursor: "pointer" }}
                className="searchbar-cross"
                onClick={() => {
                  setRecommendations([]);
                  setSearchEpisodeIdentifier("");
                  setAppliedFilters((prev) => ({ ...prev, episode_identifier: [""] }))
                }}
              />
            )}
            <div className="search-recommendations">
              {isRecommendationsLoading ? (
                <div className="loader">
                  <Spinner />
                </div>
              ) : (
                recommendations?.map((item, idx) => (
                  <li
                    key={idx}
                    onClick={() =>
                      handleSearchRecommendClick(item)
                    }
                    className="search-recommendation"
                  >
                    {/* {item.episode_identifier} */}
                    EpisodeID: {item}
                  </li>
                ))
              )}
            </div>
          </div>
          <div>
            {!flagauditRows && !unassined_page && (
              <div
                className="filter-wrapper"
                style={{ cursor: "pointer" }}
                onClick={toggleModal}
              >
                <span style={{ marginRight: "5px" }}>
                  {" "}
                  <FilterIcon />
                </span>
              </div>
            )}
          </div>

          <div style={{ cursor: "pointer" }}>

            <span
              className="workflow-refresh-btn"
              onClick={handleRefreshClick}
            >
              {/* <strong>Refresh Data</strong> */}
              <span>
                {/* <img src={refresh} alt="img" /> */}
                <RiRefreshLine />
              </span>
            </span>

          </div>
          <WorkFlowFilters
            appliedFilters={appliedFilters}
            setAppliedFilters={setAppliedFilters}
            showModal={showModal}
            onApply={handleFilterClick}
            filtersObj={filtersObj}
            setFiltersObj={setFiltersObj}
            onCancel={toggleModal}
            openAccordion={openAccordion}
            setOpenAccordion={setOpenAccordion}
          />
        </div>
      </div>
    </>
  );
}

export default Navbar;
